import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function ContactForm({
  defaultSection = "auto",
  section,          // if set → hides dropdown and fixes section
  defaultSubject = "",
  submitLabel,
  tid = "contact-form",
}) {
  const fixedSection = section || null;
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    subject: defaultSubject,
    message: "",
    section: fixedSection || defaultSection,
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form, name: `${form.first_name} ${form.last_name}`.trim() };
      delete payload.first_name; delete payload.last_name;
      await api.post("/contact", payload);
      toast.success("Richiesta inviata. Ti ricontatteremo al più presto.");
      setForm({ first_name: "", last_name: "", email: "", phone: "", subject: defaultSubject, message: "", section: fixedSection || defaultSection });
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Invio fallito");
    } finally {
      setLoading(false);
    }
  };

  const sections = [
    { v: "auto", l: "Auto" },
    { v: "moto", l: "Moto" },
  ];

  return (
    <form
      id="form"
      onSubmit={submit}
      className="card-flat p-6 md:p-10 space-y-5"
      data-testid={tid}
    >
      <div>
        <span className="label-eyebrow text-[color:var(--nsa-orange)]">Scrivici</span>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <Input label="Nome*" name="first_name" value={form.first_name} onChange={onChange} required testid="contact-first-name" />
        <Input label="Cognome*" name="last_name" value={form.last_name} onChange={onChange} required testid="contact-last-name" />
        <Input label="Email*" name="email" type="email" value={form.email} onChange={onChange} required testid="contact-email" />
        <Input label="Telefono" name="phone" value={form.phone} onChange={onChange} testid="contact-phone" />
        {!fixedSection && (
          <div className="md:col-span-2">
            <label className="label-eyebrow text-gray-500 block mb-2">Sezione</label>
            <select
              name="section"
              value={form.section}
              onChange={onChange}
              className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3 bg-white"
              data-testid="contact-section"
            >
              {sections.map((s) => (
                <option key={s.v} value={s.v}>{s.l}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      <Input label="Oggetto*" name="subject" value={form.subject} onChange={onChange} required testid="contact-subject" />

      <div>
        <label className="label-eyebrow text-gray-500 block mb-2">Messaggio*</label>
        <textarea
          name="message"
          value={form.message}
          onChange={onChange}
          rows={5}
          required
          className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3"
          data-testid="contact-message"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="btn-orange label-eyebrow px-6 py-4 inline-flex items-center gap-3 disabled:opacity-60"
        data-testid="contact-submit"
      >
        {loading ? "Invio..." : (submitLabel || "INVIA RICHIESTA")} <Send size={16} />
      </button>
    </form>
  );
}

function Input({ label, testid, ...props }) {
  return (
    <div>
      <label className="label-eyebrow text-gray-500 block mb-2">{label}</label>
      <input
        {...props}
        className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3 bg-white"
        data-testid={testid}
      />
    </div>
  );
}
